import React, { Component, PropTypes } from "react";
// import ReactHighcharts from 'react-highcharts';

import { media, boolStyle } from "../../../../utils/style-utils";
import {
	NitroLoading,
	NitroContentNotAvailable,
	NitroPanel,
	NitroIconTabs,
	NitroDivider
} from "nitro-components";

import {
	DriversPanel,
	DriverTelematicsChart,
	DriverDetailsPanel,
	DriverSafetyDetails
} from "./components";

import SectionHeader, {
	LeftSection,
	RightSection
} from "../../../../components/layouts/SectionHeader";

import ActionLinks from "../ActionLinks";
import DriverSafetyTableView from "./DriverSafetyTableView";

import { groupBy } from "lodash";

import styled from "styled-components";

const DriverSafetyChartView = styled.div`
	display: flex;
	flex-direction: row;

`;

const Container = styled.div`
	position: relative;
`;

const DriverPanelContainer = styled.div`
	width: 30%;
`;

const DriverDetailsContainer = styled.div`
	width: 70%;
	padding: 40px;
	 box-shadow: inset 7px 0 9px -7px rgba(0,0,0,0.15);
`;

const ExportAction = styled.div`
  display: inline-block;
  margin-right: 30px;
`;

const SwitchContainer = styled.div`
	position: absolute;
	right: 36px;
	top:30px;
`;

const InsightDetailTable = styled.div`
  max-height: 600px;
  width: 100%;
  overflow: auto;
   margin-top: 10px;
  ${boolStyle("hide", "display: none;")}
  ${media.mobileTablet`margin-top: 50px;`}
  ${boolStyle("hide", "display: none;")}
`;

class DriverSafetyDetailedView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			driverDetails: {},
			display: "Chart",
			driverTematicsDetails: [],
			driverLicenseReviewDetails: [],
			driverAccidentsDetails: [],
			driverList: []
		};
		this.getUpdatedDriverList = this.getUpdatedDriverList.bind(this);
		this.viewDriverDetails = this.viewDriverDetails.bind(this);
	}

	componentDidMount() {
		this.setData();
	}

	setData = () => {
		const item = groupBy(this.props.data.Data[0].Details, "Groupname");
    const driverList = this.getDriverList();
    this.setState({
      telematicsAvailable: this.props.data.TelematicsInfoAvailable, 
			driverDetails: item.DriverInformation[0],
			driverTematicsDetails: item.TelematicsData || [],
			driverLicenseReviewDetails: item.LicenseReview,
			driverAccidentsDetails: item.Accidents,
			driverList: driverList,
			noContentAvailable: false
		});
	};

	getDriverList = () => {
		const list = this.props.data.Data.map((item, i) => {
			return item.Details[0];
		});
		return list;
	};

	viewDriverDetails = selectedDriver => {
		const selectedItem = this.props.data.Data.filter((item, i) => {
			if (selectedDriver.DriverId === item.Details[0].DriverId) {
				return item;
			}
		});
		const result = groupBy(selectedItem[0].Details, "Groupname");
		this.setState({
			driverDetails: result.DriverInformation[0],
			driverTematicsDetails: result.TelematicsData || [],
			driverLicenseReviewDetails: result.LicenseReview,
			driverAccidentsDetails: result.Accidents
		});
	};

	onSearchDriver = text => {
		const driverList = this.getDriverList();
		const filteredDrivers = driverList.filter((item, i) => {
			if (item.DriverName.toLowerCase().indexOf(text) != -1) {
				return item;
			}
		});
		if (filteredDrivers.length) {
			this.setState(
				{
					driverList: filteredDrivers,
					noContentAvailable: false
				},
				this.viewDriverDetails(filteredDrivers[0])
			);
		} else {
			this.setState({
				driverList: filteredDrivers,
				noContentAvailable: true
			});
		}
	};

	getUpdatedDriverList = key => {
		switch (key) {
			case "allDriver":
				this.setState({
					driverList: this.getDriverList()
				});
				break;
			case "riskyDrivers":
				const driverList = this.getDriverList();
				const riskyDrivers = driverList.filter((item, i) => {
					if (item.PotentialSuspension) {
						return item;
					}
				});
				this.setState({
					driverList: riskyDrivers
				});
				break;
			default:
				this.setState({
					driverList: this.getDriverList()
				});
		}
	};

	switchDisplay = link => {
		if (link.label === "Chart") {
			this.setData();
		}
		this.setState({
			display: link.label
		});
	};

  openDetails = (filters) => {
	  filters=filters||{};
	  filters['FilterKeyId']=this.state.driverDetails.DriverId;
	  this.props.openDetails(filters);
  };
  
	render() {
		const { data, plotOptions } = this.props;
		const { display } = this.state;
		const displayLinks = [
			{ label: "Chart", icon: "graph-view" },
			{ label: "Table", icon: "table-view" }
		];

		console.log(data);

		if (data) {
			return (
				<Container>
					{display === "Chart" &&
						<NitroPanel padding="0px">
							<DriverSafetyChartView>
								<DriverPanelContainer>
									<DriversPanel
										data={this.state.driverList}
										onSelectDriver={this.viewDriverDetails}
										onSearchDriver={this.onSearchDriver}
										getUpdatedDriverList={
											this.getUpdatedDriverList
										}
									/>
								</DriverPanelContainer>
								{!this.state.noContentAvailable &&
									<DriverDetailsContainer>
										<DriverDetailsPanel
											data={this.state.driverDetails}
										/>
										<DriverSafetyDetails
											potentialSuspension={
												this.state.driverDetails
													.PotentialSuspension
											}
											licenseReviewData={
												this.state
													.driverLicenseReviewDetails
											}
											accidentData={
												this.state
													.driverAccidentsDetails
											}
                      openDetails={this.openDetails}
										/>

										<NitroDivider />

										<DriverTelematicsChart
											driverId={
												this.state.driverDetails
													.DriverId
                        }
                        driverName={
                          this.state.driverDetails
                            .DriverName
                        }
											telematicsAvailable={
												this.state.telematicsAvailable
											}
											data={
												this.state.driverTematicsDetails
                      }
                      sendGetTelematicsEmail={this.props.sendGetTelematicsEmail}
										/>
									</DriverDetailsContainer>}
								{this.state.noContentAvailable &&
									<DriverDetailsContainer>
										<NitroContentNotAvailable />
									</DriverDetailsContainer>}

							</DriverSafetyChartView>
						</NitroPanel>}
					{display === "Table" &&
						<NitroPanel padding="20px 0px 40px 40px">
							<InsightDetailTable>
								<DriverSafetyTableView
									telematicsAvailable={
                        this.state.telematicsAvailable
									}
									data={data.Data}
                   openDetails={this.props.openDetails}
                   sendGetTelematicsEmail={this.props.sendGetTelematicsEmail}
								/>
							</InsightDetailTable>
						</NitroPanel>}

					<SwitchContainer>
						<ExportAction>
						<ActionLinks
							exportCSV={this.props.exportCSV}
							exportChart={this.props.exportChart}
							availableOptions={["csv"]}
						/>
					</ExportAction>
						<NitroIconTabs
							active={display}
							action={this.switchDisplay}
							layout="horizontal"
							data={displayLinks}
							size="1"
							variant="secondary"
						/>
					</SwitchContainer>
				</Container>
			);
		} else {
			return <NitroLoading center thickness={2} size={24} />;
		}
	}
}

DriverSafetyDetailedView.propTypes = {
	exportOptions: PropTypes.object,
	plotOptions: PropTypes.object,
	getFilteredDrivers: PropTypes.func,
	data: PropTypes.object.isRequired,
  openDetails: PropTypes.func,
  sendGetTelematicsEmail: PropTypes.func,
	error: PropTypes.bool, // TODO .isRequired
	exportCSV:PropTypes.func,
	exportChart:PropTypes.func
};

export default DriverSafetyDetailedView;



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/DriverSafetyDetailedView.js